var render = function render(){var _vm=this,_c=_vm._self._c;return _c('el-container',{staticStyle:{"height":"100vh"}},[_c('el-aside',{attrs:{"width":"250px"}},[_c('AppAside')],1),_c('el-container',[_c('el-header',[_c('AppHeader',{on:{"changeTheme":_vm.getColor}})],1),_c('el-main',[_c('el-card',{staticClass:"box-card"},[_c('router-view')],1)],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }